import React from 'react';
import { SectionHeader } from './SectionHeader';
import { ArticleCard } from './ArticleCard';
import { PlusButton } from './PlusButton';
interface Article {
  imageUrl: string;
  title: string;
  description: string;
  category: string;
}
interface ArticleRowProps {
  category: string;
  articles: Article[];
}
export function ArticleRow({
  category,
  articles
}: ArticleRowProps) {
  return <div className="flex flex-col w-full" data-id="element-28">
      <SectionHeader label={category} data-id="element-29" />
      <div className="relative -mt-4" data-id="element-30">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-[37px]" data-id="element-31">
          {articles.map((article, idx) => <ArticleCard key={idx} index={idx} imageUrl={article.imageUrl} title={article.title} description={article.description} category={article.category} data-id="element-32" />)}
        </div>
        <div className="absolute -right-3 lg:-right-5 top-[25%] hidden md:block" data-id="element-33">
          <PlusButton size="sm" data-id="element-34" />
        </div>
      </div>
    </div>;
}